import React from 'react';
import styles from './VisuallyHidden.module.css';

export interface VisuallyHiddenProps {
  children?: React.ReactNode;
}

export const VisuallyHidden = ({ children }: VisuallyHiddenProps) => {
  return <span className={styles['visually-hidden']}>{children}</span>;
};

export default VisuallyHidden;
